"use client";

import React, { useState, useEffect } from "react";
import cookieIconLight from "../../utils/CookieIcon.svg";
import cookieIconDark from "../../utils/CookieIconDarkTheme.svg";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";

import "./CookiesComponent.css";

const CookiesComponent = () => {
  const { t } = useTranslation();
  const [showPopup, setShowPopup] = useState(false);
  const [isCookiesAccept, setIsCookiesAccept] = useState(false);
  // 'theme' will be 'light' or 'dark'
  const theme = useSelector((state) => state.cssmode.cssmode);
  const userData = useSelector((state) => state.user.user);
  const jwtToken = useSelector((state) => state.user.jwtToken);
  const isUserLogin = !!jwtToken;
  const expirationDays = 7;

  const handleAccept = () => {
    Cookies.set("cookie-consent", "accepted", { expires: expirationDays });
    setShowPopup(false);
    setIsCookiesAccept(true);
    handleSaveData();
  };

  const handleDecline = () => {
    Cookies.set("cookie-consent", "declined", { expires: expirationDays });
    setShowPopup(false);
  };

  const handleSaveData = () => {
    Cookies.set("user-name", userData?.user?.name, { expires: expirationDays });
    Cookies.set("user-email", userData?.user?.email, {
      expires: expirationDays,
    });
    Cookies.set("user-number", userData?.user?.mobile, {
      expires: expirationDays,
    });
    Cookies.set("user-token", userData?.jwtToken, { expires: expirationDays });
    Cookies.set("user-fcmId", userData?.fcm_token, { expires: expirationDays });
    Cookies.set("user-loginType", userData?.authType, {
      expires: expirationDays,
    });
  };

  useEffect(() => {
    const consent = Cookies.get("cookie-consent");
    if (!consent) {
      setShowPopup(true);
    }
  }, []);

  useEffect(() => {
    if (isUserLogin && isCookiesAccept) {
      handleSaveData();
    }
  }, [isUserLogin, showPopup, userData]);

  if (!showPopup) return null;

  // We no longer need to add a "dark" class here. The CSS will handle it globally.
  return (
    <div className="cookie-popup-container">
      <div>
        {/* Corrected <image> to <img> and fixed the src logic.
                    Based on your original code, it seems you want the dark icon for the light theme and vice-versa.
                */}
        <img
          src={theme === "light" ? cookieIconLight : cookieIconDark}
          height={70}
          width={70}
          alt="cookie-icon"
          loading="lazy"
          className="cookie-icon"
        />
      </div>
      <div className="cookie-text-container">
        <span className="cookie-title">{t("allCokkies")}</span>
        <span className="cookie-description">{t("weUseCokkies")}</span>
      </div>
      <div className="cookie-button-container">
        <button
          onClick={handleDecline}
          className="cookie-button cookie-button-decline"
        >
          {t("declineCokkies")}
        </button>
        <button
          onClick={handleAccept}
          className="cookie-button cookie-button-accept"
        >
          {t("acceptCokkies")}
        </button>
      </div>
    </div>
  );
};

export default CookiesComponent;
